<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
    <div class="service_se">
        <div class="heading_sert">
            <h3>Services / Packages</h3>
        </div>
        <div class="chip_services_list">
            <mat-chip-list class="example-chip">
               <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
           </mat-chip-list>
        </div>
    </div>

    <div class="service_create_sd">
    <div class="row">
        <div class="col-sm-10">
           <div class="serv_heading">
            <h3>{{datalength}} Services of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="create_btn_sd">
            <button mat-flat-button color="primary" [matMenuTriggerFor]="menu" *ngIf="selectedBusiness.is_owner == 1">
                <mat-icon>add</mat-icon> 
                Add service
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onCreateNewService()">
                <mat-icon class="material-icons-outlined">border_color</mat-icon>
                <span >Add manually</span>
            </button>
            <button mat-menu-item (click)="onCreateNewServiceFromTemplate()">
                <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
                <span>Add from template</span>
            </button>
        </mat-menu>
      </div>
    </div>

    <div class="search-bar-custom">
        <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input [formControl]="searchString" (keyup)="searchServiceData()" matInput placeholder="Search for services">
            <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon>close</mat-icon>
      </button>
        </mat-form-field>
    </div>
    </div>

    <div class="service_card_sedf" *ngIf="serviceList.length > 0 && !hideDiv">
        <div class="row">
            <div class="col-sm-3 servicend" *ngFor="let item of serviceList">
                <div class="serv_sect">
            <mat-card class="service-card">
              <mat-card-header class="hy_secf">
                <div mat-card-avatar class="header-avatar">
                    <div class="red_dot_ser" *ngIf="item.status == 7"></div>
                    <div class="green_dot_ser" *ngIf="item.status == 1"></div>
                    
                    <img *ngIf="selectedBusiness.revenue_model == 1" [src]="item.imgUrl" onerror="this.src='../../../../assets/images/salon_support_header.png'" alt="Service image">
                    <img *ngIf="selectedBusiness.revenue_model == 2" [src]="item.imgUrl" onerror="this.src='../../../../assets/images/fitness_services_placeholder.png'" alt="Service image">
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options" *ngIf="selectedBusiness.is_owner == 1">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="onEdit(item)">
                        <mat-icon class="material-icons-outlined">edit</mat-icon>
                        <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="changeStatus(item,1)" *ngIf="item.status == 7">
                        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                        <span>Activate</span>
                    </button>
                    <button mat-menu-item (click)="changeStatus(item,7)" *ngIf="item.status == 1">
                        <mat-icon class="material-icons-outlined">unpublished</mat-icon>
                        <span>Deactivate</span>
                    </button>
                    <button mat-menu-item (click)="deleteService(item)">
                        <mat-icon class="material-icons-outlined">delete</mat-icon>
                        <span>Delete</span>
                    </button>
                </mat-menu>
                
            </mat-card-header>
            <mat-card-content>
                <div class="header_ftgt">
                    <mat-card-title
                        matTooltip="{{ item.serviceName }}"
                        matTooltipPosition="above"
                        class="mat-card-title ellipsis-2">
                        {{ item.serviceName }}
                        </mat-card-title>
                    <mat-card-subtitle>{{item.service_type}} | {{item.approxTime}} Min</mat-card-subtitle>
                </div>
                <div class="rates" *ngIf="!item.discountStatus || item.discountStatus == null || item.discountStatus == 0">
                    <div class="rate-item" *ngIf="item.home_rate != '-'">
                        <span class="rate-label">Home Rate</span>
                      
                        <span class="rate-value" *ngIf="item.homeDiscountedPrice == '-'">
                            <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                            <span class="discounted-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                        </span>
                    </div>
                    <div class="rate-item" *ngIf="item.shop_rate != '-'">
                        <span class="rate-label">Shop Rate</span>
                        
                        <span class="rate-value" *ngIf="item.shopDiscountedPrice == '-'">
                            <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                            <span class="discounted-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                        </span>
                    </div>
                    <div class="rate-item" *ngIf="item.virtual_rate != '-'">
                      <span class="rate-label">Virtual Rate</span>
                     
                      <span class="rate-value" *ngIf="item.virtual_discounted_amount == '-'">
                          <!-- <span class="original-rate" >{{item.currency_symbol}}1299</span> -->
                          <span class="discounted-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                      </span>
                  </div>
                    <!-- <div class="rate-item">
                        <span class="rate-label">Shop Rate</span>
                        <span class="rate-value">
                            <span class="original-rate">{{item.currency_symbol}}1199</span>
                            <span class="discounted-rate">{{item.currency_symbol}}799</span>
                        </span>
                    </div> -->
                </div>
                <div class="" *ngIf="item.discountStatus && item.discountStatus != null && item.discountStatus != 'null' && item.discountStatus == 1">
              <div class="rate-item" *ngIf="item.home_rate != '-'">
                  <span class="rate-label">Home Rate</span>
                  <span class="rate-value" *ngIf="item.homeDiscountedPrice != '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.homeDiscountedPrice.toFixed(2)}}</span>
                  </span>
                  <span class="rate-value" *ngIf="item.homeDiscountedPrice == '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.home_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                  </span>
                
              </div>
              <div class="rate-item" *ngIf="item.shop_rate != '-'">
                  <span class="rate-label">Shop Rate</span>
                  <span class="rate-value" *ngIf="item.shopDiscountedPrice != '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}{{item.shopDiscountedPrice.toFixed(2)}}</span>
                  </span>
                  <span class="rate-value" *ngIf="item.shopDiscountedPrice == '-'">
                      <span class="original-rate">{{item.currency_symbol}}{{item.shop_rate.toFixed(2)}}</span>
                      <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                  </span>
                  
              </div>
              <div class="rate-item" *ngIf="item.virtual_rate != '-'">
                <span class="rate-label">Virtual Rate</span>
                <span class="rate-value" *ngIf="item.virtual_discounted_amount != '-'">
                    <span class="original-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                    <span class="discounted-rate">{{item.currency_symbol}}{{item.virtual_discounted_amount.toFixed(2)}}</span>
                </span>
                <span class="rate-value" *ngIf="item.virtual_discounted_amount == '-'">
                    <span class="original-rate">{{item.currency_symbol}}{{item.virtual_rate.toFixed(2)}}</span>
                    <span class="discounted-rate">{{item.currency_symbol}}0.00</span>
                </span>
               
            </div>
          </div>
               
                <p class="description" [matTooltip]="item.description">
                    {{item.description | ellipsify: 80}}
                </p>
            </mat-card-content>

        </mat-card>
    </div>
    </div>



<!--  -->




    </div>
    </div>

    <mat-paginator
    *ngIf="serviceList.length > 0 && !hideDiv"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator>
       <!-- Placeholder design html start -->
       <div class="placeholder_started" *ngIf="serviceList.length == 0 && !hideDiv">
        <div class="row">
          <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/placeholder-service.avif">
                 </div>
                 <mat-card-title>Contrary to popular belief, Lorem Ipsum is not simply  text.</mat-card-title>
                 <mat-card-content>The built-in and extensible SEO tools ensures your store is found first when a shopper is looking to make a purchase.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/service-list-01.jpg">
                 </div>
                 <mat-card-title>No service to show</mat-card-title>
                 <mat-card-content>
                    All the services offered by your business will appear here with all details. Start adding one now.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu" *ngIf="selectedBusiness.is_owner == 1">
                       <mat-icon>add</mat-icon>
                      Add service
                    </button>
                    <mat-menu #menu="matMenu">
                      <button  mat-menu-item (click)="onCreateNewService()">
                        <mat-icon class="material-icons-outlined">border_color</mat-icon>
                        <span>{{ 'services.manual_service' | translate }}</span>
                      </button>
                      <button  mat-menu-item (click)="onCreateNewServiceFromTemplate()">
                        <mat-icon class="material-icons-outlined"> fact_check</mat-icon>
                        <span>{{ 'services.template_service' | translate }}</span>
                      </button>
                     
                    </mat-menu>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/add-service.png">
                 </div>
                 <mat-card-title>How to add service?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')">help document</span> on creating services against a business. You can check this video as well.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding service or if there's any issue while adding service, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
    <div class="">
        <div class="heading_sert">
            <h3>Services</h3>
        </div>
    </div>

       <!-- Placeholder design html start -->
       <div class="placeholder_started__business">
        <div class="row">
          <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet.</mat-card-title>
                 <mat-card-content>To add your services you need to create a business first. Services will be added under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new" >
              <mat-card appearance="outlined" style="">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>Access denied.</mat-card-title>
                 <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                </mat-card-content>
                 
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/add-service.png">
                 </div>
                 <mat-card-title>How to add service?</mat-card-title>
                 <mat-card-content>Check our <a href="https://lookzup.com/help" target="_blank" class="ghtunderline">  help document</a> on creating services against a business. You can check this video as well.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding service or if there's any issue while adding service, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
    
      
</section>